import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'js-cookie';
import { getUserState } from '@carvana/core-auth';

const BCID = 'BrowserCookieId'

const initDataDog = () => {
  datadogRum.init({
    applicationId: '497f97be-97d1-46b0-b4db-0c5203121977',
    clientToken: 'pub167ede1ae3bf1682b89763d96a38f7a5',
    service: 'cltv-oem-mycar-ui',
    env: process.env.NODE_ENV || 'development',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.setUser({
    // must use id since datadog's queryable columns are not dynamic
    id: Cookies.get(BCID),
    userId: getUserState().user?.user_id,
  });

  datadogRum.startSessionReplayRecording();
};

export default initDataDog;
